import { z } from 'zod'
import { oc } from '@orpc/contract'

export const declineOrganizationConnect = oc
  .route({ method: 'POST', path: '/v2/organizations/connects/{id}/decline' })
  .input(z.object({ id: z.string() }))
  .output(
    z.object({
      id: z.string(),
      status: z.literal('declined'),
      initiator: z.object({ id: z.string(), name: z.string() }),
      declinedBy: z.object({ id: z.string(), name: z.string() }),
    }),
  )
